
class ShareOnSocialMedia {
  static init(...parameters) {
    return new ShareOnSocialMedia(...parameters);
  }

  constructor(container) {
    const shareLinks = container.querySelectorAll('.share-links a');
    let shareWindow = null;

    [...shareLinks].forEach((link) => {
      if (link.classList.contains('pinterest')) {
        return;
      }
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const shareLink = e.currentTarget.href;
        const windowOptions = 'width=600, height=500, menubar=no, centerscreen=yes';
        if (shareWindow === null || shareWindow.closed) {
          shareWindow = window.open(shareLink, 'shareWindow', windowOptions);
        } else {
          shareWindow.location = shareLink;
          shareWindow.focus();
        }
      });
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-share-on-social-media', ShareOnSocialMedia.init);
}
